// extracted by mini-css-extract-plugin
export var button = "k_W";
export var button1 = "k_X";
export var button2 = "k_Y";
export var button3 = "k_Z";
export var button4 = "k_0";
export var button5 = "k_1";
export var buttonInner = "k_2";